import React from "react";

export default function AdminFooter() {
  return (
    <div
      className="bg-light"
      style={{ height: "100%", minHeight: "100%", position: "relative" }}
    ></div>
  );
}
